/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export default function PayOther(props) {
  const payment = props.payment || {};
  const provider = props.provider || {};
  const selectedMethod = payment.selectedMethod;
  const setSelectedMethod = payment.setSelectedMethod;
  const setProviderData = provider.setData;
  const PaymentSelect = props.PaymentSelect || selectedMethod;
  const setPaymentSelect = props.setPaymentSelect || setSelectedMethod;
  const setProvider = props.setProvider || setProviderData;

  const paymentMethods = useSelector(state => state.master.paymentMethods);
  const paymentSetting = useSelector(state => state.payment.paymentSetting);

  const [PaymentChannelList, setPaymentChannelList] = useState([
    {
      paymentChannelID: 8,
      paymentChannelName: 'ใช้คะแนนแลกส่วนลด',
      icon: 'point',
      disabled: false,
      code: 'POINT'
    },
    {
      paymentChannelID: 9,
      paymentChannelName: 'บันทึกลูกหนี้',
      icon: 'debtors',
      disabled: false,
      code: 'ACCOUNT_RECEIVABLE'
    }
  ]);

  useEffect(() => {
    if (paymentMethods && paymentMethods.length > 0) {
      const methodsMap = {};
      paymentMethods.forEach(method => {
        methodsMap[method.name] = {
          code: method.code,
          id: method.id,
          type: method.type
        };
      });

      const updatedChannels = [
        {
          paymentChannelID: 8,
          paymentChannelName: 'ใช้คะแนนแลกส่วนลด',
          icon: 'point',
          disabled: !isMethodEnabled('ใช้คะแนนแลกส่วนลด'),
          id: methodsMap['ใช้คะแนนแลกส่วนลด']?.id,
          code: methodsMap['ใช้คะแนนแลกส่วนลด']?.code || 'POINT',
          methodId: methodsMap['ใช้คะแนนแลกส่วนลด']?.id || 8,
          type: methodsMap['ใช้คะแนนแลกส่วนลด']?.type || 'OTHER'
        },
        {
          paymentChannelID: 9,
          paymentChannelName: 'บันทึกลูกหนี้',
          icon: 'debtors',
          disabled: !isMethodEnabled('บันทึกลูกหนี้'),
          code: methodsMap['บันทึกลูกหนี้']?.code || 'ACCOUNT_RECEIVABLE',
          id: methodsMap['ใช้คะแนนแลกส่วนลด']?.id,
          methodId: methodsMap['บันทึกลูกหนี้']?.id || 9,
          type: methodsMap['บันทึกลูกหนี้']?.type || 'OTHER'
        }
      ];

      setPaymentChannelList(updatedChannels);
    }
  }, [paymentMethods, paymentSetting]);

  const isMethodEnabled = methodName => {
    if (!paymentSetting) return false;

    switch (methodName) {
      case 'ใช้คะแนนแลกส่วนลด':
        return paymentSetting.is_discount_received;
      case 'บันทึกลูกหนี้':
        return paymentSetting.is_debtor_received;
      default:
        return true;
    }
  };

  const handleBackToMainChannels = () => {
    const cashCode = paymentMethods?.find(m => m.name === 'เงินสด')?.code || 'CASH';
    const cashId = paymentMethods?.find(m => m.name === 'เงินสด')?.id || 1;

    const newPaymentSelect = {
      paymentChannelID: 0,
      paymentChannelName: 'รายละเอียด',
      icon: 'detail',
      code: cashCode,
      methodId: cashId
    };

    if (typeof setSelectedMethod === 'function') {
      setSelectedMethod(newPaymentSelect);
    } else if (typeof setPaymentSelect === 'function') {
      setPaymentSelect(newPaymentSelect);
    }
  };

  const handleSelectPaymentChannel = item => {
    if (typeof setSelectedMethod === 'function') {
      setSelectedMethod(item);
    } else if (typeof setPaymentSelect === 'function') {
      setPaymentSelect(item);
    }

    if (typeof setProviderData === 'function') {
      setProviderData(null);
    } else if (typeof setProvider === 'function') {
      setProvider(null);
    }
  };

  const currentPaymentMethod = selectedMethod || PaymentSelect;

  return (
    <div style={{ minHeight: '280px' }}>
      <div className="row mb-0">
        <div className="col-4">
          <button
            className={`btn px-1 text-[#FFF] btn-select-payment back bg-[#2DC76D]`}
            onClick={handleBackToMainChannels}
          >
            <div className="pay-icon"></div>
            <div className="lh">กลับช่องทางหลัก</div>
          </button>
        </div>
        {PaymentChannelList &&
          PaymentChannelList.map((item, index) => (
            <div className="col-4" key={index}>
              <button
                className={`btn btn-select-payment ${item.icon} ${
                  currentPaymentMethod?.paymentChannelID === item.paymentChannelID ? 'active' : ''
                }`}
                onClick={() => handleSelectPaymentChannel(item)}
                disabled={item.disabled}
              >
                <div className="pay-icon"></div>
                <div className="lh">{item.paymentChannelName}</div>
              </button>
            </div>
          ))}
      </div>

      {currentPaymentMethod?.paymentChannelID === 9 && (
        <div className="mt-4 p-3 bg-light rounded">
          <h5 className="mb-3">บันทึกลูกหนี้</h5>
          <p className="text-muted">บันทึกการชำระเงินเป็นลูกหนี้เพื่อชำระในภายหลัง</p>
        </div>
      )}
    </div>
  );
}
